export const heroCards = [
  {
    id: "h1",
    tag: "年度焦点",
    title: "「临时取消直播」持续发酵：一条时间线看懂整季话题",
    summary: "从当晚的一句预告，到第二天的深夜长文，话题在两周内被反复推回首页。",
    comments: 4821,
    date: "09.12",
  },
  {
    id: "h2",
    tag: "月度盘点",
    title: "删帖与复出之后，围观者最关心的三个未解细节",
    summary: "回应视频下架、超话清空、商务暂停，几个动作的时间点几乎踩在同一周。",
    comments: 3260,
    date: "09.08",
  },
  {
    id: "h3",
    tag: "资料合集",
    title: "一张活动合影被逐帧放大，评论区从站位聊到关系",
    summary: "同框名单不断被补充，二创与解读接力，让这张照片活了整整半个月。",
    comments: 2984,
    date: "09.02",
  },
  {
    id: "h4",
    tag: "关注热榜",
    title: "带货口播与后台数据对不上，长评区成了半个复盘现场",
    summary: "选品、话术、退款率被逐项拆解，围观者的耐心比想象中更足。",
    comments: 5117,
    date: "08.29",
  },
];

export const navItems = [
  { label: "首屏焦点", href: "#top" },
  { label: "热门排行", href: "#ranking" },
  { label: "名单", href: "#names" },
  { label: "合集", href: "#collections" },
  { label: "年度汇总", href: "#year" },
  { label: "热评", href: "#comments" },
];

export const rankList = [
  {
    rank: "01",
    title: "深夜长文引发连锁反应",
    summary: "一篇千字回应带出后续三次补充说明，讨论度连续七天不降。",
    heat: 98,
    comments: 4821,
    tag: "焦点",
  },
  {
    rank: "02",
    title: "同框合影引爆关系猜测",
    summary: "活动现场的三张照片被反复比对，评论区自发整理时间线。",
    heat: 94,
    comments: 3164,
    tag: "资料",
  },
  {
    rank: "03",
    title: "直播口播翻车合集被补齐",
    summary: "从报错价格到口误品牌，每一段切片都被单独截出归档。",
    heat: 91,
    comments: 2984,
    tag: "直播",
  },
  {
    rank: "04",
    title: "商务合作突然终止",
    summary: "多个品牌连夜撤下物料，合作方态度成为讨论焦点。",
    heat: 87,
    comments: 2210,
    tag: "商务",
  },
  {
    rank: "05",
    title: "旧视频被翻出重新解读",
    summary: "三年前的一条日常视频被重新剪辑，评论区开始补充上下文。",
    heat: 84,
    comments: 1876,
    tag: "考古",
  },
  {
    rank: "06",
    title: "超话清空引发退出猜测",
    summary: "相关内容一夜消失，围观者开始比对过往的清理习惯。",
    heat: 80,
    comments: 1542,
    tag: "动态",
  },
  {
    rank: "07",
    title: "回应视频下架又重新上架",
    summary: "两次版本细节略有不同，被逐帧截图做成对照表。",
    heat: 76,
    comments: 1360,
    tag: "回应",
  },
  {
    rank: "08",
    title: "粉丝团内部公告流出",
    summary: "一份群内通知被转发到公开平台，讨论走向出现明显转向。",
    heat: 72,
    comments: 1189,
    tag: "粉丝",
  },
];

export const nameGroups = [
  {
    category: "直播与带货",
    icon: "ri-live-line",
    desc: "以直播节奏、选品话术与口播争议为主线的话题整理。",
    items: [
      { name: "夜航小鹿", note: "跨年直播口误被剪成合集，后续补充说明三次。" },
      { name: "汽水不加糖", note: "选品清单与后台数据对不上，长评区逐项复盘。" },
      { name: "三点半不睡", note: "临时取消连麦，当晚登上讨论榜前列。" },
      { name: "海盐粒子", note: "报错价格后秒改口，片段被反复转发。" },
    ],
  },
  {
    category: "短视频与日常",
    icon: "ri-video-line",
    desc: "成于日常分享，也常因一条旧内容被重新讨论。",
    items: [
      { name: "北纬三十七", note: "三年前日常视频被翻出，评论区补齐上下文。" },
      { name: "旧巷口的猫", note: "拍摄花絮被逐帧解读，讨论集中在取景地。" },
      { name: "晚风收音机", note: "一句口播被做成循环切片，热度维持两周。" },
      { name: "一颗菠萝", note: "停更公告发布后，旧动态被集中回看。" },
    ],
  },
  {
    category: "话题与商务",
    icon: "ri-megaphone-line",
    desc: "争议多集中在商务合作与公开回应的节奏上。",
    items: [
      { name: "栗子同学", note: "合作物料一夜撤下，品牌动作被做成时间线。" },
      { name: "橘子汽水", note: "两次回应版本不同，被截图对照。" },
      { name: "柠檬半糖", note: "工作室声明措辞反复修改，引发二次讨论。" },
      { name: "半格胶片", note: "联名延期公告发布，评论区开始补档。" },
    ],
  },
];

export const collectionList = [
  {
    title: "年度大事件合集",
    desc: "把全年讨论度最高的几十个节点按时间顺序排好。",
    count: 36,
    tag: "年度",
  },
  {
    title: "直播翻车现场合集",
    desc: "口误、报错价、临时下播，集中在一处回看。",
    count: 52,
    tag: "直播",
  },
  {
    title: "回应与道歉合集",
    desc: "从第一条声明到后续补充，逐条对照看变化。",
    count: 28,
    tag: "回应",
  },
  {
    title: "同框与合影合集",
    desc: "活动照片与现场物料，按场合分类归档。",
    count: 41,
    tag: "资料",
  },
  {
    title: "商务翻车与解约合集",
    desc: "品牌动作与撤物料时间点，一并留档。",
    count: 19,
    tag: "商务",
  },
  {
    title: "考古旧视频合集",
    desc: "被重新翻出来讨论的早期内容，附上下文。",
    count: 63,
    tag: "考古",
  },
];

export const timelineList = [
  {
    month: "01 月",
    title: "开年第一波 · 跨年直播口误",
    summary: "一句话被截成短视频，成为新年第一个被反复转发的片段。",
    tag: "直播",
  },
  {
    month: "03 月",
    title: "春季商务合作集中调整",
    summary: "多个品牌在同一个月换掉主推，围观者开始整理时间线。",
    tag: "商务",
  },
  {
    month: "05 月",
    title: "合影风波 · 同框名单被补齐",
    summary: "活动现场照片被逐帧比对，评论区自发补充名单。",
    tag: "资料",
  },
  {
    month: "07 月",
    title: "旧视频考古季",
    summary: "一批早期日常内容被重新剪辑，讨论热度持续整个夏天。",
    tag: "考古",
  },
  {
    month: "09 月",
    title: "深夜长文与补充说明",
    summary: "一篇回应带出连续三次补充，成为年度最长寿的话题之一。",
    tag: "回应",
  },
  {
    month: "11 月",
    title: "年度汇总收束",
    summary: "把全年节点按题材重新归档，形成可集中浏览的年度总结。",
    tag: "年度",
  },
];

export const commentList = [
  {
    id: "c1",
    user: "夜航小鹿",
    initial: "夜",
    time: "3 分钟前",
    content: "整理得挺全的，时间线一看就懂，省得自己到处翻。",
    likes: 328,
  },
  {
    id: "c2",
    user: "汽水不加糖",
    initial: "汽",
    time: "12 分钟前",
    content: "合集这个思路好，比零散刷到强多了，建议一直做下去。",
    likes: 256,
  },
  {
    id: "c3",
    user: "北纬三十七",
    initial: "北",
    time: "刚刚",
    content: "排行里那条考古的我居然没看过，先去补课了。",
    likes: 198,
  },
  {
    id: "c4",
    user: "栗子同学",
    initial: "栗",
    time: "1 小时前",
    content: "希望名单能把上下文也带上，单看标题容易误会。",
    likes: 164,
  },
  {
    id: "c5",
    user: "三点半不睡",
    initial: "三",
    time: "2 小时前",
    content: "评论区比正文还精彩，大家把细节都补得差不多了。",
    likes: 142,
  },
  {
    id: "c6",
    user: "半格胶片",
    initial: "半",
    time: "昨天",
    content: "年度汇总这块可以再往前扩一点，前年的内容也想看。",
    likes: 117,
  },
];